export const RESOURCE: string = 'osman';

export interface IOsmanCompany {
    id: number;
    code: string;
    name: string;
    text: string;
    isActive: boolean;
    group: string;
    isVendor: boolean;
    isBuyer: boolean;
    isDistributor: boolean;
    defaultCurrencyCode: string;
    currency?: string;
    currencyCodes: string;
    email: string;
    telephone: string;
    address: string;
    namelistMethod: string;
    defaultContact: IContact;
    contacts: IContact[];
    managerUsers: IUser[];
    consultantUsers: IUser[];
    nameListTemplate: string;
    retrocessionTemplate: string;
    convocationTemplate: string;
}

export interface IUser {
    id: number;
    contactId: number;
    lastName: string;
    firstName: string;
    login: string;
}

export interface IContact {
    id: number;
    code: string;
    company: {
        id: number;
        code: string
    };
    xTitle: string;
    lastName: string;
    firstName: string;
    initials: string;
    email: string;
    telephone: string;
    address: string;
    remark: string;
    isActive: boolean;
}
